import { useLocation, useParams } from "react-router-dom";
import { getSingleSwitchable } from "./functions";
import { codeTemplate } from "./constants";
import { useContext, useEffect, useMemo } from "react";
import { SwitchableContext } from "./context";
import hljs from "highlight.js";
import "highlight.js/styles/github.css";

const useQuery = () => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};

const getQuerySearch = (lang = "") => {
  let paramQuery = new URLSearchParams();
  if (lang) {
    paramQuery.set("lang", lang);
  }
  return paramQuery.size > 0 ? `?${paramQuery.toString()}` : "";
};

const ChairsSingle = (): JSX.Element => {
  const { dataType } = useContext(SwitchableContext);
  const { experienceID } = useParams();
  const experience = getSingleSwitchable(dataType, experienceID);
  const query = useQuery();
  const lang = query.get("lang") || "";
  const embedAddress =
    process.env.NODE_ENV === "development"
      ? `//localhost:3000/viewer/${dataType === "chairs" ? "massagechairs" : "saunas"}`
      : `//brand3d-ar.web.app/viewer/${dataType === "chairs" ? "massagechairs" : "saunas"}`;
  useEffect(() => {
    const codeElement = document.getElementById("brand3d-embed-code");
    if (codeElement) {
      codeElement.removeAttribute("data-highlighted");
      hljs.highlightElement(codeElement);
    }
  });
  if (!experience) {
    return <></>;
  }
  return (
    <div className="content">
      <h1>{experience.name}</h1>
      {/* START OF 3D EXPERIENCE */}
      <div className="brand3d-iframe-viewer-internal">
        <iframe
          title={experience.name}
          src={`${embedAddress}/${experienceID}`}
          seamless
          width="100%"
          height="700px"
          allow="clipboard-read; clipboard-write"
          className="brand3d-embedded-iframe"
        ></iframe>
      </div>
      {/* END OF 3D EXPERIENCE */}
      {/* START OF EMBED CODE BOX */}
      <hr />
      <h2>Embed code:</h2>
      <pre>
        <code aria-readonly id="brand3d-embed-code">
          {codeTemplate
            .replace("%title%", experience.name)
            .replace("%embed_address%", embedAddress)
            .replace("%id%", experience.id)
            .replace("%options%", getQuerySearch(lang))}
        </code>
      </pre>
      {/* END OF EMBED CODE BOX */}
      <hr />
      <hr />
      {/* START OF NOTES */}
      <div className="brand3d-embed-code-notes">
        <h4>Notes:</h4>
        <ul>
          <li>
            The embed in this page has a white background for clarity purposes,{" "}
            <i>the copied code does NOT include this white background.</i>
          </li>
          <li>
            The CSS snippet included in the embed code is completely optional;
            but it's a good place to start testing customizations to the embed.
          </li>
        </ul>
      </div>
      {/* END OF NOTES */}
    </div>
  );
};

export default ChairsSingle;
